import { Cell } from "../scenes/Board/Cell";

export class CellsPool {

    public static currentScene: Phaser.Scene; 

    private static maxCapacity: number = 0; 
    private static ammount: number = 0; 
    private static ammountToCreate: number = 0; 
    private static poolArray: Cell[]; 

    public static init(scene: Phaser.Scene) {

        // Init Variables 
        CellsPool.currentScene = scene; 
        CellsPool.maxCapacity = 400; // To fill a 40 x 40 image 
        CellsPool.ammountToCreate = 100; 
        CellsPool.ammount = 0; 

        CellsPool.poolArray = [];

        this.createCells(CellsPool.maxCapacity);    
    }

    public static push(newCell: Cell): void {   

        CellsPool.poolArray.push(newCell); 
        CellsPool.ammount++;
    }

    public static getCell(): Cell {

        // Check if we have avaliable cells to return 
        let newCell: Cell; 

        if (CellsPool.ammount === 0) {
            this.createCells(this.ammountToCreate); 
        }

        if (CellsPool.ammount > 0) {

            // Return a cell
            newCell = CellsPool.poolArray.pop(); 
            newCell.setNull(); 
            CellsPool.ammount--; 
        }

        return newCell;       
    }

    private static createCells(toCreate: number): void {

        for (let i = 0; i < toCreate; i++) {    
                  
            let newCell = new Cell(CellsPool.currentScene, null, 0, 0, new Phaser.Display.Color(255, 255, 0), new Phaser.Display.Color(255, 255, 0), 0);
            newCell.ignoreDestroy(); 
            CellsPool.poolArray.push(newCell);
            CellsPool.ammount++; 
        }
    } 
}
